import get from 'lodash/get';
import * as api from 'auth/resources/two-factor.api';
import template from './confirm-two-factor-dialog.html';

class ConfirmTwoFactorDialogController {
  async confirm() {
    try {
      const params = {
        resourceOwnerCredentials: this.resolve.credentials,
        code: this.code,
        remember: this.remember || false,
      };
      const tokens = await api.confirmTwoFactorCode(params);
      this.close({ $value: tokens });
    } catch (error) {
      console.error(error);
      this.showErrorCode = true;
      const errorCode = get(error, 'data.errors[0].code');
      if (['ACCOUNT_LOCKED', '2FA_CODE_BLOCKED'].includes(errorCode)) {
        this.close({ $value: error });
      }
    }
  }
}

export default class ConfirmTwoFactorDialogComponent {
  constructor() {
    this.template = template;
    this.controller = ConfirmTwoFactorDialogController;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/components/two-factor/components/confirm-two-factor-dialog/confirm-two-factor-dialog-component.js